import { render, staticRenderFns } from "./BlockAgents.vue?vue&type=template&id=78db7c7d&scoped=true&"
import script from "./BlockAgents.vue?vue&type=script&lang=js&"
export * from "./BlockAgents.vue?vue&type=script&lang=js&"
import style0 from "./BlockAgents.vue?vue&type=style&index=0&id=78db7c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db7c7d",
  null
  
)

export default component.exports